import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AutoPaymentFilter, AutoPaymentResponse, AutoPaymentUpdate } from 'src/app/class/datatype';

@Injectable()
export class AutoPaymentService {

  constructor(
    private http: HttpClient,
  ) { }

  listPayment(filter: AutoPaymentFilter): Observable<AutoPaymentResponse> {
    let params = new HttpParams();

    if (filter.regcode) {
      params = params.append('regcode', filter.regcode.toString());
    }

    if (filter.bank) {
      params = params.append('bank', filter.bank.toString());
    }

    if (filter.nominal) {
      params = params.append('nominal', filter.nominal.toString());
    }

    if (filter.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<AutoPaymentResponse>(environment.apiUrl + 'clientapi/auto-payment', {params});
  }

  savePayment(data: AutoPaymentUpdate): Observable<any> {
    return this.http.put(environment.apiUrl + 'clientapi/auto-payment', data);
  }

}
